import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell } from "@/components/layout/SiteShell";
import { PageHero } from "@/components/marketing/PageHero";
import { Btn, SectionHeader } from "@/components/marketing/primitives";
import { ChannelMap } from "@/components/marketing/ChannelMap";
import { PartnerBadges } from "@/components/marketing/PartnerBadges";
import { ContactCTA } from "@/components/marketing/ContactCTA";
import { TrustRibbon } from "@/components/marketing/TrustRibbon";
import { FAQSection } from "@/components/marketing/FAQSection";
import { SERVICES_HUB_FAQS, faqJsonLd } from "@/content/faqs";
import { OG_IMAGE, abs } from "@/content/siteConfig";
import { automationLinks } from "@/content/aiAutomation";

export const Route = createFileRoute("/services/")({
  head: () => ({
    meta: [
      { title: "Services: Google and Meta Ads, LSA, YouTube, SEO & AI Search | BHG" },
      {
        name: "description",
        content:
          "Google Ads, Meta Ads, Local Services Ads, and YouTube: run together for service businesses, local brands, and growth-focused operators.",
      },
      { property: "og:title", content: "Services: Google and Meta Ads, LSA, YouTube, SEO & AI Search | BHG" },
      {
        property: "og:description",
        content:
          "Google, Meta, LSA, and YouTube: run together as a single integrated growth engine.",
      },
      { property: "og:url", content: abs("/services") },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: abs("/services") }],
    scripts: [
      { type: "application/ld+json", children: faqJsonLd(SERVICES_HUB_FAQS) },
    ],
  }),
  component: ServicesIndex,
});

function ServicesIndex() {
  return (
    <SiteShell>
      <PageHero
        eyebrow="Services"
        lede={
          <>
            Four channels, one integrated lead engine. We don&apos;t sell content packages, we
            run paid media as the asset.
          </>
        }
        ctas={<Btn to="/contact">Start with an audit →</Btn>}
      >
        Four channels. One <span className="display-italic">thesis.</span>
      </PageHero>

      <TrustRibbon />


      <section className="bhg-section">
        <div className="wrap">
          <SectionHeader
            num="What we run"
            title={<>The <span className="display-italic">channels.</span></>}
          />
          <p className="prose-lead mt-6">Existing demand you can capture shows up in search volume and Local Services Ads eligibility. Demand you have to create needs Meta and YouTube.</p>
          <ChannelMap />
          <div className="services-automation-group">
            <h2>AI &amp; Automation</h2>
            {automationLinks.map(item => <Link key={item.to} to={item.to} className="services-automation-row"><span>{item.label}<small>{item.description}</small></span><span aria-hidden="true">→</span></Link>)}
          </div>
        </div>
      </section>

      <PartnerBadges />

      <FAQSection items={SERVICES_HUB_FAQS} />

      <ContactCTA />
    </SiteShell>
  );
}
